import type { FieldPath, FieldValues, UseFormSetError } from 'react-hook-form';
import { getFieldErrors } from '@/services/api';

const API_TO_FORM_FIELD: Record<string, string> = {
  body_html: 'bodyHtml',
  change_note: 'changeNote',
  document_type: 'documentType',
  dealer_id: 'dealerId',
};

export function applyServerFieldErrors<T extends FieldValues>(
  error: unknown,
  setError: UseFormSetError<T>,
  fieldMap: Record<string, string> = {},
): boolean {
  const fieldErrors = getFieldErrors(error);
  const entries = Object.entries(fieldErrors);
  for (const [apiField, messages] of entries) {
    const field = (fieldMap[apiField] ?? API_TO_FORM_FIELD[apiField] ?? apiField) as FieldPath<T>;
    setError(field, { type: 'server', message: messages[0] ?? 'Invalid value' });
  }
  return entries.length > 0;
}

export const isConflict = (error: unknown): boolean => (error as { status?: number })?.status === 409;
